import { MAX_CONTENT_WIDTH } from "@faire/retailer-visitor-shared/features/Marketplace/styleConsts";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import styled, { css } from "styled-components";

export const Z_INDICES = {
  footer: {
    desktopAndAbove: 1,
  },
  sidebar: {
    desktopAndAbove: 0,
    tablet: 102,
    mobile: 101,
  },
};

export const ElevatedContentWrapper = styled(Column)<{ $maxWidth?: number }>`
  width: 100%;
  ${responsiveMediaQueries.desktopAndAbove} {
    ${({ $maxWidth }) => css`
      max-width: ${$maxWidth ?? MAX_CONTENT_WIDTH}px;
    `}
    margin: auto;
    padding: 0 ${getSpacing("6x")};
  }

  ${responsiveMediaQueries.tabletAndBelow} {
    padding-left: 0px;
  }
`;
